<div class="container">
    <app-template [title]="'FT Single Result Template'">
          <form [formGroup]="Form" (ngSubmit)="Submit($event)">
            <div class="form">
                  <span class="input">
                    <mat-form-field>
                        <mat-label>Subject</mat-label>
                        <input formControlName="Name" matInput placeholder="">
                      </mat-form-field>
                  </span>
                  <div class="space"></div>
                <angular-editor [config]="editorConfig" [placeholder]="'Enter text here...'" formControlName="Template_Text"></angular-editor>
  
                <div class="errorMessage">
                    <div *ngIf="Errors" class="error">
                        <p>{{Errors}}</p>
                    </div>
                </div>
                <button type="submit" class="create" mat-raised-button color="primary">
                    {{ isLoading? "Sending...": "Send"}}
                  </button>
                <div class="space"></div>
            </div>
            
        </form>
    </app-template>
  </div>